import { Box, Image, Text } from "native-base";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Images } from "../constants";
import { getOrganisation } from "../helpers/userHelpers";
import { getBrandSelector } from "../slices/brandSlice";
import { userSelector } from "../slices/userSlice";
import LottieAnimation from "./LottieAnimation";
import ShimmerText from "./ShimmerText";

interface PostOnboardingLoadingInterstitialProps {
  size?: "sm" | "lg";
}

const PostOnboardingLoadingInterstitial: React.FC<PostOnboardingLoadingInterstitialProps> = ({ size = "lg" }) => {
  const { t } = useTranslation();
  const [messageIndex, setMessageIndex] = useState(0);

  const user = useSelector(userSelector);
  const organisation = user ? getOrganisation(user) : undefined;
  const brand = useSelector(getBrandSelector);

  const messages = t("loading_component.messages", {
    organisation_name: organisation?.name || "all",
    first_name: user?.first_name || "you",
    returnObjects: true,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000); // Update every 3 seconds

    return () => clearInterval(interval);
  }, [messages]);

  return (
    <Box flex={1} safeArea bg="primary.10" alignItems="center" justifyContent="center" p={4}>
      <Image
        source={{ uri: brand?.logo }}
        width={["200", "250", "300"]}
        height={["200", "250", "300"]}
        alt="Organization Logo"
        mb={0}
        resizeMode="contain"
      />
      <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={-2}>
        {t("loading_component.title")}
      </Text>
      <LottieAnimation
        source={Images.PrepareFoodAnimation}
        width={size === "lg" ? ["250", "300", "350"] : 50}
        height={size === "lg" ? ["250", "300", "350"] : 50}
        autoPlay
        loop
        testID="loading-animation"
      />
      <Box mt={10} mb={0} alignItems="center" px={8}>
        <ShimmerText fontSize="lg" color="function.40" textAlign="center" fontStyle="italic">
          {messages[messageIndex]}
        </ShimmerText>
      </Box>
    </Box>
  );
};

export default PostOnboardingLoadingInterstitial;
